import { Component, OnInit, ViewChild, EventEmitter } from "@angular/core";

import { FilterConfigView } from "../filter-config.view";
@Component({
    selector: "filter-customize-display",
    templateUrl: "./filter-customize-display.view.html",
    providers: []
})
export class FilterCustomizeDisplaySectionView extends FilterConfigView {}
